module.exports = __webpack_public_path__ + "img/sphy_banner.a39ebe47.png";